<div class="row py-5 border-bottom">

  <div class="col-md-6 col-xl-3 mt-xl-0 offset-xl-3">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 0" [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 0" (click)="switchTo(0)">
      Fechas<br>De Ciclo
    </button>
  </div>

  <div class="col-md-6 mt-2 col-xl-3 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 1" [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 1" (click)="switchTo(1)">
      Compañías<br>Incluidas
    </button>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 0">


  <div class="mt-5 row">

    <div class="col-md-4 offset-xl-4">
      <mat-form-field>
        <input matInput [matDatepicker]="inicioDeCalculoPicker" placeholder="Dia de Calculo:" (dateChange)="setStartDate($event)" [value]="startDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="inicioDeCalculoPicker"></mat-datepicker-toggle>
        <mat-datepicker #inicioDeCalculoPicker></mat-datepicker>
      </mat-form-field>
    </div>

  </div>

  <div class="row">

    <div class="col-md-4 bottom-vertically offset-xl-4">
      <button class="btn btn-block btn-primary" (click)="addDate()">Añadir Fecha Excepción</button>
    </div>

  </div>

  <div class="my-5 row border-top" *ngIf="modPayrollParameter && modPayrollParameter.payrollDates.length > 0">
    <div class="col-md-12">

      <mat-table #payrollDatesTable class="table" [dataSource]="modPayrollParameter.payrollDates">

        <ng-container matColumnDef="End">
          <mat-header-cell *matHeaderCellDef>Fecha Fin Meta 4</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') : ''}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Start">
          <mat-header-cell *matHeaderCellDef>Fecha De Pago</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Week">
          <mat-header-cell *matHeaderCellDef>Número De<br>Semana</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.weekNumber}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="BiWeek">
          <mat-header-cell *matHeaderCellDef>Número De<br>Catorcena</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.biWeekNumber}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="day">
          <mat-header-cell *matHeaderCellDef> Dia </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.scheduleDay !== null ? scheduleDay(element.scheduleDay) : ''}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef> Candado </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [(ngModel)]="element.active">Candado Activo</mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete" class="center-text">
          <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
          <mat-cell *matCellDef="let index = index">
            <button mat-icon-button color="warn" (click)="deleteLoanDate(index)">
              <mat-icon aria-label="Delete">delete_outline</mat-icon>
            </button>

          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedLoanDatesColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedLoanDatesColumns;"></mat-row>

      </mat-table>

    </div>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 1">

  <div class="mt-5 row">

    <div class="col-md-12">

      <mat-table #companiesTable class="table" [(dataSource)]="companies">

        <ng-container matColumnDef="companyID">
          <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Nombre de la Compañía </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="taxationIdentificationNumber">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Documento Legal </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.taxationIdentificationNumber}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Incluir Compañía
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="changeCompanies($event,row)" [checked]="selectionCompanies.isSelected(row)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedCompanyColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedCompanyColumns;"></mat-row>
      </mat-table>

    </div>

  </div>

</div>